<template>
   <div class="layout">
        <div class="layout__header">
            <h3>Feriados</h3>
        </div>
        <k-table :filterStatus="filterStatus" @crear="crear" :createButton="createButton" 
        :editButton="false" :deleteButton="false" ref="listaFeriados" 
        @seleccionar="seleccionar" :path="url + '/feriados/search'" :columns="[
            {
                display : 'Descripción',
                value : 'descripcion'
            },
            {
                display : 'Fecha',
                value : 'fecha'
            },
            {
                display : 'Fecha de creación',
                value : 'created_at'
            },
            {
                display : 'Fecha de modificación',
                value : 'updated_at'
            }
        ]">
        </k-table>
        <modal :width="'80%'" height="auto" :scrollable="true"  name="feriado">
            <feriado :searchButton="searchButton" @created="createdFeriado"></feriado>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        createButton : {
            type : Boolean,
            required : false,
            default : true
        },
        filterStatus : {
            type : Boolean,
            required : false,
            default : true
        },
        searchButton : {
            type : Boolean,
            required : false,
            default : false
        }
    },
    data : function () {
        return {
            currentIndex : -1,
            url : url
        }
    },
    methods : {            
        seleccionar : function(currentFeriado) {
            this.$emit('selected', currentFeriado);
        },
            crear : function () {
            this.$modal.show('feriado');
        },
        createdFeriado: function (marca) {
            this.$refs.listaFeriados.actualizarLista(marca);
            this.$modal.hide('feriado');
        }
    }

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/feriados/ListaFeriados.vue